import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const CodeDiplome = [
  'Doctorat',
  'MasterPro',
  'MasterRecherche',
  'MasterIndifferent',
  'DiplomeIngenieurCommerce',
  'AutreBac5EtPlus',
  'PremiereAnneeMaster',
  'LicencePro',
  'LicenceGenerale',
  'BUT',
  'AutreBac3Et4',
  'BTS',
  'DUT',
  'AutreBac2',
  'BacPro',
  'BacGeneral',
  'BacTechno',
  'AutreBac',
  'CAP',
  'BEP',
  'MentionComplementaire',
  'AutreCAPBEP',
  'Brevet',
  'CertificatFormationGenerale',
  'AucunDiplomeNiTitre',
] as const

export type CodeDiplome = typeof CodeDiplome[number]

export const DiplomeLibelle: UnionTypeLibelle<CodeDiplome> = {
  Doctorat: 'Doctorat',
  MasterPro: 'Master professionnel/DESS',
  MasterRecherche: 'Master recherche/DEA',
  MasterIndifferent: 'Master indifférencié',
  DiplomeIngenieurCommerce: "Diplôme d'ingénieur, diplôme d'école de commerce",
  AutreBac5EtPlus: 'Autre diplôme ou titre de niveau bac+5 ou plus',
  PremiereAnneeMaster: '1ère année de Master',
  LicencePro: 'Licence professionnelle',
  LicenceGenerale: 'Licence générale',
  BUT: 'Bachelor Universitaire de technologie BUT',
  AutreBac3Et4: 'Autre diplôme ou titre de niveau bac +3 ou 4',
  BTS: 'Brevet de Technicien Supérieur',
  DUT: 'Diplôme Universitaire de technologie',
  AutreBac2: 'Autre diplôme ou titre de niveau bac+2',
  BacPro: 'Baccalauréat professionnel',
  BacGeneral: 'Baccalauréat général',
  BacTechno: 'Baccalauréat technologique',
  AutreBac: 'Autre diplôme ou titre de niveau bac',
  CAP: 'CAP',
  BEP: 'BEP',
  MentionComplementaire: 'Mention complémentaire',
  AutreCAPBEP: 'Autre diplôme ou titre de niveau CAP/BEP',
  Brevet: 'Diplôme national du Brevet',
  CertificatFormationGenerale: 'Certificat de formation générale',
  AucunDiplomeNiTitre: 'Aucun diplôme ni titre professionnel',
} as const
